import styled, { css } from "styled-components";
import { color } from "../../../atoms/colors";
import { font } from "../../../atoms/typography";

export const CalcForm = styled.form`
  display: grid;
  grid-row-gap: 6px;
`

export const Label = styled.label`
  ${font('text', 'sm', '500')}
  color: ${color.common.black};
`

export const Input = styled.input`
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 30px;
  padding: 10px 14px;
  ::placeholder {
    ${font('text', 'reg', '400')}
    color: ${color.grey[400]};
  }
`

export const ErrorMessage = styled.div`
  ${font('text', 'lg', '400')}
  color: ${color.grey[600]};
  ${(props => props?.label && css`
    ${font('text', 'sm', '400')}
    color: red;
  `)}
`